import PropTypes from 'prop-types';
import { tippingGoalType, userType, getBuyIcon, getBuyText, BUY_TYPES } from './FeedHelper';
import Flux from '../../flux/Flux';
import FeedTipping from './FeedTipping';
import { getCommonTranslation } from '../../utils/TranslationHelper';
import { formatCurrency } from '../../utils/CommonUtils';

export default function FeedPostNeedsTippingGoal({ id, tippingGoal, model, isMobile, type, needAvs }) {
	if (!Flux.Guest.isLoggedIn()) {
		return null;
	}

	return (
		<div className={'feed-tipping_goal--wrapper' + (needAvs ? ' feed-tipping_goal--avs' : '')}>
			<div className={'feed-tipping_goal'}>
				{!needAvs && (
					<div className="feed-tipping_goal__info">
						{getBuyIcon(type, BUY_TYPES.TG)}
						{getBuyText(model.name, 'feed.need-tip-text--')}
					</div>
				)}
				<div className={'feed-tipping_goal-text'}>
					{!(tippingGoal.achieved && isMobile) && getCommonTranslation('tippinggoal-title')}
					<span className={'feed-tipping_goal-text-goal'}>
						{tippingGoal.achieved
							? getCommonTranslation('tippinggoal-reached')
							: getCommonTranslation('tippinggoal-goal', formatCurrency(tippingGoal.goalCoins))}
					</span>
				</div>
				<div className={'feed-tipping_goal-progress-wrapper'}>
					<div className={'feed-tipping_goal-progress'} style={{ width: tippingGoal.progressPercent + '%' }}>
						{formatCurrency(tippingGoal.tipsSumCoins)}
					</div>
				</div>
				<FeedTipping postId={id} showTipping={true} model={model} isMobile={isMobile} isTippingGoal={true} />
			</div>
		</div>
	);
}

FeedPostNeedsTippingGoal.propTypes = {
	isMobile: PropTypes.bool,
	id: PropTypes.string,
	tippingGoal: PropTypes.shape(tippingGoalType),
	model: PropTypes.shape(userType),
	type: PropTypes.string,
	needAvs: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
};
